import createReducer from 'utils/redux/createReducer'

const initialState = {
	period: 'YTD'
  , property: 'total'
  , report: 'Income Statement'
  , templates: {}
  , perfomancePeriod: 'YTM'
}

export default createReducer(initialState, {
	SET_PERIOD: (currentState, action) => ({...currentState, period: action.data})
  , SET_PROPERTY: (currentState, action) => ({...currentState, property: action.data, report: 'Monthly Statement'})
  , SET_REPORT_TYPE: (currentState, action) => ({...currentState, report: action.data})
  , TEMPLATE_GOT: (currentState, action) => ({
		...currentState
	  , templates:{
			[action.data.id]: action.data.template
		}
	})
  , SET_PERFOMANCE_PERIOD: (currentState, action) => ({...currentState, perfomancePeriod: action.data})
})



// WEBPACK FOOTER //
// ./src/reducers/finance.js